import React, { useEffect, useState } from "react";
import { Flex, Dialog, CloseIcon, Button, Alert, ProviderConsumer } from "@fluentui/react-northstar";
import { LifecycleTask } from "../utils/typings";
import { PhaseTaskForm } from "./PhaseTaskForm";
import { BUTTONS, LIFECYCLE } from '../../shared/utils/constants';


interface Props {
  open: boolean;
  onCancel: () => void;
  saveTask: (data: LifecycleTask) => void;
  initData: LifecycleTask;
  userList: PlatformUser[];
}

export const PhaseTaskDialog = ({ open, onCancel, saveTask, initData, userList }: Props) => {

  const [taskData, setTaskData] = useState<LifecycleTask>(initData);
  
  const closeDialog = () => {
    setAlert({ title: '', show: false, attributes: {} });
    onCancel();
    setTaskData(initData);
  }
  const [alert, setAlert] = useState({
    title: '',
    show: false,
    attributes: {}
  });
  const validateRequired = () => {
    setAlert({ title: '', show: false, attributes: {} });
    if (taskData.Name  === '') {
      setAlert({
        title: LIFECYCLE.REQUIRED_FIELD_MESSAGE,
        show: true,
        attributes: { danger: true }
      });
      return true;
    }
    return false;
  };
  const primaryClick = async () => {
    if (validateRequired()) return;
    saveData();
    onCancel();
    setTaskData(initData);
  }
  useEffect(() => {
    if (open) {
      setAlert({ title: '', show: false, attributes: {} });
      setTaskData(initData);
    }
  }, [open]);
  
  const renderPages = () => {
    return <PhaseTaskForm
      taskData={taskData}
      setTaskData={setTaskData}
      userList={userList}
    />
  }

  const saveData = () => {
    saveTask(taskData);
  }

  return (
    <Dialog className="relate-ticket-dialog"
      content={renderPages()}
      open={open}
      headerAction={{
        icon: <CloseIcon />,
        title: LIFECYCLE.CLOSE,
        onClick: closeDialog
      }}
      header={{
        content: (
          <div className="w-full">
            <h3 className="mt-0">{(taskData.Guid.length > 0) ? BUTTONS.EDIT : LIFECYCLE.ADD} {LIFECYCLE.TASK}</h3>
            {alert.show && (
              <Alert
                fitted
                {...alert.attributes}
                content={alert.title}
                className="w-full text-xs"
              />
            )}
          </div>
        ),        
      }}
      footer={
        <ProviderConsumer 
          render={(_globalTheme) => (
            <Flex gap="gap.small">
              <>
                <Flex.Item push>
                  <Button content={BUTTONS.CANCEL} onClick={closeDialog} />
                </Flex.Item>
                <Button className="dialog-btn"
                  content={(taskData.Guid.length > 0) ? BUTTONS.SAVE : LIFECYCLE.ADD}
                  primary onClick={primaryClick}
                />
              </>
            </Flex>
          )}
        />
      }
    />
  )
};